export enum FIREBASE_PROJECTID {
  PROD = "scaffcalc-prod",
  DEV = "scaffcalc-dev",
  LOCAL = "local",
}
